module.exports = __webpack_public_path__ + "img/ignis.5b32cfcb.svg";